// extracted by mini-css-extract-plugin
export var brand = "_2o-9";
export var button = "_2o-0";
export var chevron = "_2o-v";
export var chevronButton = "_2o-w";
export var content = "_2o-n";
export var danger = "_2o-g";
export var dangerOutlined = "_2o-h";
export var dark = "_2o-l";
export var darkTheme = "_2o-c";
export var extraSmall = "_2o-4";
export var fullWidth = "_2o-8";
export var ghost = "_2o-d";
export var gray = "_2o-t";
export var icon = "_2o-p";
export var iconButton = "_2o-s";
export var iconButtonBorder = "_2o-x";
export var iconButtonBorderDark = "_2o-y";
export var iconButtonBorderLight = "_2o-z";
export var iconLeft = "_2o-q";
export var iconRight = "_2o-r";
export var large = "_2o-1";
export var light = "_2o-m";
export var medium = "_2o-2";
export var micro = "_2o-5";
export var nano = "_2o-7";
export var outlined = "_2o-k";
export var pending = "_2o-a";
export var primary = "_2o-i";
export var shadow = "_2o-o";
export var small = "_2o-3";
export var solidLight = "_2o-e";
export var solidLightBrand = "_2o-f";
export var spinner = "_2o-u";
export var transparent = "_2o-j";
export var warning = "_2o-b";
export var wideNano = "_2o-6";